export default {
  // Hero
  hotelHeroKicker: 'About us',
  hotelHeroTitle1: 'One house.',
  hotelHeroTitle2: 'Warm-hearted people.',
  hotelHeroTitle3: 'Genuine hospitality.',
  hotelHeroLead: 'The Alpenhof stands for Bavarian hospitality, personal care and a place where guests truly feel welcome.',
  hotelHeroCareerInline: 'We are hiring',
  hotelHeroCareerCardKicker: '✦ We are hiring',
  hotelHeroCareerCardText: 'Looking for warm-hearted people →',

  // Tradition
  hotelTradTitle: 'Tradition meets the present',
  hotelTradText1: 'What began in 1911 as the villa of an author is today a place where history feels alive – without standing still. The Alpenhof combines Bavarian tradition with contemporary comfort and hospitality that comes from the heart.',
  hotelTradText2: 'Run by a family, shaped by the people who work here – and brought to life by guests who keep coming back.',

  // Values
  hotelValuesKicker: 'Our values',
  hotelValuesTitle: 'What defines us',
  hotelValuesLead: 'Three things have shaped the Alpenhof since the very beginning – and make it what it is today.',
  hotelVal1Title: 'A warm welcome',
  hotelVal1Text: 'We don’t just receive our guests – we welcome them in. With attentiveness, warmth and the feeling of really being expected.',
  hotelVal2Title: 'High quality',
  hotelVal2Text: 'Sleep like a baby, breakfast like a king.',
  hotelVal3Title: 'A perfect location',
  hotelVal3Text: 'Between lake, city and Alps – the Alpenhof sits right where Bavaria is at its most beautiful.',

  // Breakfast
  hotelBfKicker: 'Breakfast & stay',
  hotelBfTitle: 'Live like the Kini himself.',
  hotelBfLead: 'The morning at the Alpenhof begins relaxed and unhurried. Our breakfast room radiates cosiness – in summer, the garden invites you to linger.',
  hotelBfFeat1Title: 'High-quality produce',
  hotelBfFeat1Text: 'Organic products from the Andechs dairy. Rolls and bread from the local organic bakery (voted Europe’s best bakery). And many more carefully chosen ingredients.',
  hotelBfFeat2Title: 'Personal service',
  hotelBfFeat2Text: 'Would you like your breakfast egg just the way you like it? A particular coffee or tea speciality? We are happy to take care of it.',
  hotelBfFeat3Title: 'Round off the day',
  hotelBfFeat3Text: 'With a glass of wine or beer in our cosy lounge with its traditional tiled stove, in the leafy garden. Or browse our library for inspiration.',

  // Impressions
  hotelGalleryKicker: 'Impressions',
  hotelGalleryTitle: 'A look inside',
  hotelGalleryLead: 'Tradition, cosiness and Bavarian charm – tangible in every corner.',

  // CTA
  hotelCtaTitle: 'Ready for your stay?',
  hotelCtaText: 'Experience Bavarian hospitality in a house with history, heart and a perfect location.',
  hotelCtaButton: 'Check availability now',

  // Careers
  hotelCareerKicker: 'Careers',
  hotelCareerTitle: 'Working at the Alpenhof',
  hotelCareerLead: 'We are always looking for warm-hearted people who share our passion for hospitality. Get in touch – open applications are always welcome.',
  hotelJob1Title: 'Receptionist',
  hotelJob1Details: 'Part-time or full-time · Gauting',
  hotelJob2Title: 'Breakfast service staff',
  hotelJob2Details: 'Breakfast service · Part-time · Gauting',
  hotelJob3Title: 'Housekeeping staff',
  hotelJob3Details: 'Part-time · Gauting',
  hotelCareerApply: 'Apply',
  hotelCareerNoFitText: 'Nothing matching?',
  hotelCareerNoFitLink: 'We welcome open applications.',
};
